import * as React from "react";
import type { SVGProps } from "react";
const SvgArrowUpContained01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#000"
      d="M7.33 12.367a1 1 0 0 0 1.281 1.536l-.64-.768zm4.884-2.768.64-.768a1 1 0 0 0-1.28 0zm3.602 4.304a1 1 0 1 0 1.28-1.536l-.64.768zm-7.845-.768.64.768 4.243-3.535-.64-.769-.64-.768-4.243 3.536zm4.243-3.536-.64.769 4.242 3.535.64-.768.64-.768-4.242-3.536zM21.6 12h-1a8.6 8.6 0 0 1-8.6 8.6v2c5.854 0 10.6-4.746 10.6-10.6zM12 21.6v-1A8.6 8.6 0 0 1 3.4 12h-2c0 5.854 4.746 10.6 10.6 10.6zM2.4 12h1A8.6 8.6 0 0 1 12 3.4v-2C6.146 1.4 1.4 6.146 1.4 12zM12 2.4v1a8.6 8.6 0 0 1 8.6 8.6h2c0-5.854-4.746-10.6-10.6-10.6z"
    />
  </svg>
);
export default SvgArrowUpContained01;
